<template>
    <v-card class="pa-2">
        <v-card-title class="headline px-2"
            >{{ gift ? "Update" : "New" }} Gift</v-card-title
        >
        <div style="border: #5cb860 2px solid" class="py-2 mx-1">
            <v-layout row justify-space-between class="pb-2 px-2">
                <div class="heading font-weight-medium">
                    Before Purim:
                </div>
                <div class="heading font-weight-medium">
                    {{ student.beforePurimAmount | currency }}
                </div>
            </v-layout>
            <v-layout row justify-space-between class="px-2 pb-2">
                <div class="heading font-weight-medium">
                    After Purim:
                </div>
                <div class="heading font-weight-medium">
                    {{ getAfterPurimAmount() | currency }}
                </div>
            </v-layout>
            <v-layout row justify-space-between class="px-2 pb-2">
                <div class="heading font-weight-medium">
                    Paid Group:
                </div>
                <div class="heading font-weight-medium">
                    {{ student.paidGroup | currency }}
                </div>
            </v-layout>
            <v-layout row justify-space-between class="px-2">
                <div class="heading font-weight-medium">
                    Total:
                </div>
                <div class="heading font-weight-medium">
                    {{ student.totalPaid | currency }}
                </div>
            </v-layout>
        </div>
        <div class="pa-3">
            <v-select
                class="mb-4"
                :items="getGiftTypes()"
                label="Type"
                v-model="giftType"
                :rules="required"
                ref="giftType"
                hide-details
            ></v-select>
            <v-text-field
                class="mb-4"
                hide-details
                type="number"
                label="Quantity"
                v-model="quantity"
                ref="quantity"
                :rules="quantityRules"
            ></v-text-field>
            <v-text-field
                class="mb-4"
                hide-details
                type="number"
                label="Order Number"
                v-model="orderNumber"
            ></v-text-field>
            <v-text-field
                class="mb-2"
                hide-details
                label="Note"
                v-model="note"
            ></v-text-field>

            <v-checkbox
                class="my-3"
                hide-details
                label="Picked Up"
                color="success"
                v-model="pickedUp"
            ></v-checkbox>
        </div>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="default" @click="closeDialog()">Cancel</v-btn>
            <v-btn :loading="processing" color="success" @click="save()">
                Save Gift
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import moment from "moment";
import { formatCurrency, sum } from "../../utils/helpers.js";

export default {
    props: {
        student: Object,
        transactions: Array,
        reload: Function,
        closeNewGiftDialog: Function,
        getDomain: Function,
        gift: Object,
        setup: Object,
        giftSetups: Array,
    },
    components: {},
    data() {
        return {
            processing: false,
            giftType: "",
            orderNumber: "",
            quantity: 1,
            pickedUp: false,
            note: "",

            required: [(v) => !!v || "Amount Is Required"],
            quantityRules: [
                (v) => !!v || "Required",
                (v) => !v || +v > 0 || "Must be at least 1",
            ],
        };
    },
    async created() {},
    watch: {
        gift(newValue, oldValue) {
            if (newValue) {
                this.giftType = this.getGiftType(newValue.giftID);
                this.note = newValue.notes;
                this.quantity = newValue.quantity;
                this.orderNumber = newValue.orderNumber;
                this.pickedUp = newValue.isPickedUp;
            }
        },
    },
    computed: {},
    methods: {
        closeDialog() {
            this.giftType = "";
            this.note = "";
            this.quantity = 1;
            this.orderNumber = "";
            this.pickedUp = false;

            this.$refs.quantity.resetValidation();
            this.$refs.giftType.resetValidation();

            this.closeNewGiftDialog();
        },
        getGiftType(id) {
            if (!this.giftSetups) return "";

            const setup = this.giftSetups.find((g) => g.giftID == id);

            return setup.description + " - " + formatCurrency(setup.value);
        },
        getGiftID(type) {
            if (!this.giftSetups) return "";

            const value = type.split("-")[0].trim();

            const setup = this.giftSetups.find(
                (g) => g.description.trim() == value,
            );

            return setup.giftID;
        },
        getGiftTypes() {
            if (!this.giftSetups) return [];

            return this.giftSetups.map(
                (g) => g.description + " - " + formatCurrency(g.value),
            );
        },
        getAfterPurimAmount() {
            if (!this.transactions) return 0;

            const afterPurim = this.transactions
                .filter((t) => t.date >= this.setup.purimDate)
                .map((t) => t.amount);

            return sum(afterPurim);
        },
        validate() {
            return [
                this.$refs.quantity.validate(true),
                this.$refs.giftType.validate(true),
            ].every(Boolean);
        },
        async save() {
            if (!this.validate()) return;

            const isUpdating = this.gift;

            this.processing = true;

            const today = moment().format("YYYY-MM-DD HH:mm:ss");

            try {
                await this.$http.post(
                    this.getDomain() + "/api/purimStudents/addGift",
                    {
                        id: isUpdating ? this.gift.id : 0,
                        year: this.setup.currentYear,
                        date: today,
                        dateEntered: isUpdating
                            ? moment(this.gift.date).format(
                                  "YYYY-MM-DD HH:mm:ss",
                              )
                            : today,
                        quantity: this.quantity,
                        orderNumber: this.orderNumber,
                        isPickedUp: this.pickedUp,
                        studentID: this.student.studentID,
                        notes: this.note,
                        giftID: this.getGiftID(this.giftType),
                        enteredBy: isUpdating
                            ? this.gift.enteredBy
                            : this.$store.state.authentication.user,
                        dateLastUpdated: isUpdating ? today : null,
                        lastUpdatedBy: isUpdating
                            ? this.$store.state.authentication.user
                            : null,
                    },
                );

                this.processing = false;

                this.$notify({
                    text: "Gift Saved",
                    group: "notification",
                    type: "success",
                });

                this.closeDialog();

                this.reload();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
    },
};
</script>
